import {Component, OnInit} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-security-information',
    templateUrl: './security-information.component.html',
    styleUrls: ['./security-information.component.scss']
})
export class SecurityInformationComponent implements OnInit {

    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private deviceService: DeviceDetectorService,
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
    }

    ngOnInit(): void {
    }

}
